/* Medicine type-ahead (2+ letters): past Order Register medicines + Product Alias names, with known Second Name. */
import { useRef, useState } from "react";
import axios from "axios";
import { Input } from "./ui/input";
import { API, getAuthHeader } from "@/App";

export const MedicineSuggestInput = ({ value, onChange, onPick, onBlur, placeholder, testId }) => {
  const [sug, setSug] = useState([]);
  const [idx, setIdx] = useState(-1);
  const t = useRef(null);
  const picked = useRef(false);
  const type = (v) => {
    onChange(v);
    picked.current = false;
    setIdx(-1);
    if (t.current) clearTimeout(t.current);
    if (v.trim().length < 2) { setSug([]); return; }
    t.current = setTimeout(async () => {
      try {
        const r = await axios.get(`${API}/product-aliases/medicine-suggest`, { headers: getAuthHeader(), params: { q: v.trim(), limit: 8 } });
        setSug((r.data.rows || []).filter(x => x.medicine && x.medicine !== v.trim()));
      } catch { setSug([]); }
    }, 220);
  };
  const pick = (x) => { picked.current = true; setSug([]); onPick(x); };
  const key = (e) => {
    if (!sug.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setIdx(i => (i + 1) % sug.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setIdx(i => (i <= 0 ? sug.length - 1 : i - 1)); }
    else if (e.key === "Escape") setSug([]);
    else if ((e.key === "Enter" || e.key === "Tab") && idx >= 0) { e.preventDefault(); pick(sug[idx]); }
  };
  return (
    <div className="relative">
      <Input value={value} onChange={(e) => type(e.target.value)} onKeyDown={key} placeholder={placeholder} data-testid={testId}
        autoComplete="off" autoCorrect="off" spellCheck={false} enterKeyHint="next"
        onBlur={(e) => { setTimeout(() => setSug([]), 150); if (!picked.current) onBlur?.(e); picked.current = false; }} />
      {sug.length > 0 && (
        <div className="absolute left-0 right-0 top-full mt-0.5 z-50 max-h-56 overflow-auto rounded border border-slate-200 bg-white shadow-lg"
             data-testid={`${testId}-suggest-list`}>
          {sug.map((x, i) => (
            <button key={x.medicine} type="button" onMouseEnter={() => setIdx(i)} onPointerDown={(e) => { e.preventDefault(); pick(x); }}
              className={`w-full border-b border-slate-100 px-2 py-1.5 text-left last:border-0 max-md:py-2.5 ${i === idx ? "bg-indigo-100" : "hover:bg-indigo-50"}`}
              data-testid={`${testId}-suggest-item-${i}`}>
              <div className="text-xs font-semibold text-slate-800">{x.medicine}</div>
              {x.second_name && <div className="text-[10px] text-indigo-600">→ {x.second_name}</div>}
            </button>))}
        </div>)}
    </div>
  );
};
